import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { configurationLocalAccountingBillableCustomerService } from '@/modules/configurationModule/detail/local-accounting/billable/clients/services/customer-services/configuration-local-accounting-billable-clients-customer-services.service'
import { ConfigurationCustomerResponse } from '@/modules/configurationModule/detail/local-accounting/billable/clients/services/customer-services/configuration-local-accounting-billable-clients-customer-services.dto'
import { store } from '@/store/store'

export const localAccountingCustomersColumnsDef =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.client'),
            field: 'name',
            minWidth: 250,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.code'),
            field: 'code',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.modal.client.identifier'),
            field: 'taxIdentificationNumber',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.typeOfClient'),
            field: 'type.name',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.groupOfClient'),
            field: 'group.name',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.priority'),
            field: 'priorityForAutomaticAssignment',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        }
    ]

export enum ConfigurationLocalAccountingCustomersGridSidepanelComboElements {
    RATES = 1,
    RULES = 2
}

export interface ConfigurationLocalAccountingCustomersGridState extends CrudModelPaginatorLaboratory<ConfigurationCustomerResponse> {
    service: typeof configurationLocalAccountingBillableCustomerService
    laboratoryId: number
}
export const initialConfigurationLocalAccountingCustomersGridState =
    (): ConfigurationLocalAccountingCustomersGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.accounting.customers',
        columnsDef: localAccountingCustomersColumnsDef(),
        datasource: new PaginatorLaboratoryDatasource(configurationLocalAccountingBillableCustomerService, store.getters.labId),
        service: configurationLocalAccountingBillableCustomerService,
        laboratoryId: store.getters.labId
    })
